<template>
  <div style="height: 1080px">
    <app-banner />
    <div id="background">
      <app-map @loaded="mapLoaded" style="height: 940px" />
    </div>
    <div id="foreground" v-if="mapReady" style="height: 940px">
      <transition name="fade">
        <router-view />
      </transition>
    </div>
  </div>
</template>
<script>
import AppBanner from '@/components/AppBanner'
import AppMap from '@/components/AppMap.vue'
export default {
  components: { AppBanner, AppMap },
  data() {
    return {
      /**
       * 地图是否加载完成
       */
      mapReady: false,
    }
  },
  methods: {
    mapLoaded() {
      console.log('Map加载完成')
      this.mapReady = true
    },
  },
}
</script>
<style scoped>
#background {
  position: absolute;
  z-index: 888;
  top: 140px;
  left: 0;
  right: 0;
  bottom: 0;
}
#foreground {
  pointer-events: none;
  position: absolute;
  z-index: 999;
  top: 140px;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/GeneralHome.vue